<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableAction, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import CurrencysForm from './CurrencysForm.vue';
import UpdateExchangeRateModal from './UpdateExchangeRateModal..vue';

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  perm?: Permission[]
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = '/clients/finance/master-data/currency/'
const title = 'Currencys'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const fields: TableField[] = [
  { name: 'image', caption: 'Image', sortable: false, fieldType: 'image' },
  { name: 'code', caption: 'Code', sortable: true, fieldType: 'text' },
  { name: 'name', caption: 'Name', sortable: true, fieldType: 'text' },
  { name: 'exchange_rate', caption: 'Exchange Rate', sortable: true, fieldType: 'number' },
  { name: 'base_currency', caption: 'Base Currency', sortable: true, fieldType: 'checkbox', width: '150px' },
  { name: 'active', caption: 'active', sortable: false, fieldType: 'status' },
]

//dynamically get permission 
const actions: TableAction[] = [
  { name: 'update-exchange-rates', icon: 'CircleDollarSign', variant: 'primary', title: 'Update Exchange Rates', visible: (data) => !data.base_currency, ignorePermission: true },
]
const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const permissions = ref<Permission[]>()

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const showExchangeRateForm = ref(false)
const handleActions = (action: string, data: any) => {
  if (action == 'update-exchange-rates') {
    selectedData.value = data
    showExchangeRateForm.value = true
  }
}
const handleData = (data : any) => {
  selectedData.value = data
}
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "actions" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" @permissions="permissions = $event"
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" :show-next-button="showNextButton"
  @custom="handleActions">
  <template #form-view>
    <CurrencysForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
    <UpdateExchangeRateModal
      :permissions="permissions"
      v-if="showExchangeRateForm"
      :currency="selectedData"
      :end-point="endPoint"
      title="Update Exchange Rates"
      :mode="'edit'"
      @save="refreshData = !refreshData"
      @close="showExchangeRateForm = !showExchangeRateForm"
    />
  </template>
  
  </ListTemplate>
</template>